import React from 'react';
import { Tabs } from 'antd';
import { HomeOutlined, DashboardOutlined, TeamOutlined, UserOutlined, FileTextOutlined  } from '@ant-design/icons';
import '../../Styles/PrincipalAdmin.css';
import ContenidoPrincipalAdministrador from './ContenidoPrincipalAdministrador';
import DataQuery from './VerAjustadores';
import AdministracionDeCuentasAdministrador from './AdministracionDeCuentaAdministrador';
import ConsultarkilometragesGeneral from './ConsultarkilometragesGeneral';
import Indicadores from './Indicadores'


const { TabPane } = Tabs;

const PrincipalAdmin = () => {

  return (
    <div className="app-container">
      <div className="content">
        <Tabs
          defaultActiveKey="1"
          tabPosition="bottom"
          size="large"
          animated
          className="custom-tabs"
        >
          <TabPane
            tab={
              <span>
                <HomeOutlined />
              </span>
            }
            key="1"
          >
            <ContenidoPrincipalAdministrador/>
          </TabPane>

          <TabPane
            tab={
              <span>
                <TeamOutlined />
                </span>
            }
            key="2"
          >
            <DataQuery/>
          </TabPane>

          <TabPane
            tab={
              <span>
                <FileTextOutlined  />
                </span>
            }
            key="3"
          >
            <Indicadores/>
          </TabPane>

          <TabPane
            tab={
              <span>
                <DashboardOutlined />
              </span>
            }
            key="4"
          >
            <ConsultarkilometragesGeneral/>
          </TabPane>
          <TabPane
            tab={
              <span>
                <UserOutlined />
              </span>
            }
            key="5"
          >
            <AdministracionDeCuentasAdministrador/>

          </TabPane>
        </Tabs>
      </div>

    </div>
  );
};

export default PrincipalAdmin;
